var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.isModalOpen,"persistent":"","width":"480"}},[_c('modal-card',{attrs:{"title":_vm.title,"full":"","padding":"","closable":false}},[_c('p',{staticClass:"pl-2 pt-2"},[(_vm.isBanned)?[_vm._v(" You have been banned from this interview. ")]:[_vm._v(" Thank you! ")]],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }